import { render, staticRenderFns } from "./addResourceStoreType.vue?vue&type=template&id=0ccabb98"
import script from "./addResourceStoreType.vue?vue&type=script&lang=js"
export * from "./addResourceStoreType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports